import { createSlice, current } from '@reduxjs/toolkit';
import states from '../states';

const myImagesDownloadReducer = createSlice({
  name: 'myImagesDownloader',
  initialState: {
    ...states.myImagesForDownload,
  },
  reducers: {
    updateMyImagesDownloader: (state, action) => {
      let tempState = { ...current(state) };
      console.log(action?.payload);
      let returnableState = {
        ...tempState,
        ...action?.payload,
      };
      return { ...returnableState };
    },
    resetMyImagesDownloader: (state, action) => {
      let returnableState = { ...states.myImagesForDownload };
      return { ...returnableState };
    },
  },
});

export const { updateMyImagesDownloader, resetMyImagesDownloader } =
  myImagesDownloadReducer.actions;
export default myImagesDownloadReducer;
